import {
  Div,
  displayCentsInDollars,
  P,
  TextWithTooltipIcon,
} from '@vgrubs/components';
import { PartDot } from './BrandValueCard.styled';

type Props = {
  label: string;
  /** Cents. */
  amount: number;
  /** Behind the info icon: how the number comes about. */
  info?: string;
  /** A total: both sides bold. */
  strong?: boolean;
  color?: string;
  /** A part's colour, tying the line to its segment of a ValueBar. */
  dot?: string;
};

/**
 * One amount in a breakdown: the label left, the money right, the way Income
 * Details lists a payout.
 */
export const MoneyLine = ({
  label,
  amount,
  info,
  strong,
  color,
  dot,
}: Props) => (
  <Div $flex $alignCenter $between $gap="16px">
    <Div $flex $alignCenter $gap="8px" $minWidth="0">
      {dot && <PartDot $color={dot} />}
      <TextWithTooltipIcon text={label} tooltip={info} bold={strong} />
    </Div>
    <P $m="0" $noWrap $bold={strong} $color={color}>
      {displayCentsInDollars(amount)}
    </P>
  </Div>
);
